export default {
    install: (app, options) => {
        const $t = app.config.globalProperties.$t;

        app.config.globalProperties.$validationRules = {
            required: value => !!value || $t('jsValidation.This field is required'),
            integer: value => value === undefined || value === null || Number.isInteger(parseFloat(value)) || $t('jsValidation.This field must be an integer'),
            number: value => value === undefined || value === null || !isNaN(parseFloat(value)) || $t('jsValidation.This field must be a number'),
            min: (value, min) => value === undefined || value === null || parseFloat(value) >= min || $t('jsValidation.This field must be greater than or equal to') + ' ' + min,
            max: (value, max) => value === undefined || value === null || parseFloat(value) <= max || $t('jsValidation.This field must be less than or equal to') + ' ' + max,
            mimes: value => value && value[0] && value[0].type && ['image/png', 'image/jpeg'].includes(value[0].type) || $t('jsValidation.Only PNG and JPEG images are allowed'),
        }
    }
}